export default __webpack_public_path__ + "static/media/dedication.f5af12b0.svg";